import Vue from 'vue'

const LuVbox = Vue.component('lu-vbox', {
  functional: true,
  render (createElement, context) {
    context.data.staticClass = 'v-container d-flex flex-column ' + context.data.staticClass
    return createElement('div', context.data, context.children)
  }
})
const LuHbox = Vue.component('lu-hbox', {
  functional: true,
  render (createElement, context) {
    context.data.staticClass = 'v-container d-flex flex-row ' + context.data.staticClass
    return createElement('div', context.data, context.children)
  }
})

export default { LuVbox, LuHbox }
